<div class="pc-preview-stage" #stage>
  @if (showLoadingOnly) {
    <div class="pc-preview-loading" aria-busy="true">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else if (showPreviewBundle) {
    <div
      class="pc-preview-scaler"
      [class.pc-preview-scaler--busy]="showLoader"
      [style.width.px]="bundleWidthPx"
      [style.height.px]="bundleHeightPx"
      [style.transform]="scalerTransform"
    >
      <div
        class="pc-preview-pages"
        [class.pc-preview-pages--row]="usesRowLayout"
      >
        @if (hasFrontSlot) {
          <div
            class="pc-preview-card"
            [class.pc-preview-card--blank]="!hasFrontDocument"
            [style.width.px]="cardWidthPx"
            [style.height.px]="cardHeightPx"
          >
            @if (hasFrontDocument) {
              <iframe
                class="pc-preview-iframe"
                [class.pc-preview-iframe--pending]="showLoader"
                [attr.data-key]="frontIframeKey"
                [srcdoc]="safeFrontDocumentHtml"
                [width]="cardWidthPx"
                [height]="cardHeightPx"
                title=""
                tabindex="-1"
                (load)="onIframeLoad('front', $event)"
              ></iframe>
            }
          </div>
        }
        @if (hasBackSlot) {
          <div
            class="pc-preview-card"
            [class.pc-preview-card--blank]="!hasBackDocument"
            [style.width.px]="cardWidthPx"
            [style.height.px]="cardHeightPx"
          >
            @if (hasBackDocument) {
              <iframe
                class="pc-preview-iframe"
                [class.pc-preview-iframe--pending]="showLoader"
                [attr.data-key]="backIframeKey"
                [srcdoc]="safeBackDocumentHtml"
                [width]="cardWidthPx"
                [height]="cardHeightPx"
                title=""
                tabindex="-1"
                (load)="onIframeLoad('back', $event)"
              ></iframe>
            }
          </div>
        }
      </div>
      @if (showLoader) {
        <div class="pc-preview-overlay" aria-busy="true">
          <mat-spinner diameter="32"></mat-spinner>
        </div>
      }
    </div>
  } @else {
    <div class="pc-preview-placeholder">
      <mat-icon class="pc-preview-placeholder__icon">badge</mat-icon>
      <p class="pc-preview-placeholder__text">
        {{ "printCards.previewPlaceholder" | translate }}
      </p>
    </div>
  }
</div>
